<div class="container p-3">
    <div class="sc-form-header-not-dialog" i18n>
        {{title}}
    </div>

    <div class="container-fluid container-body">


        <form id="new _user_form" [formGroup]="form" name="address">

            <div class="form-group-attached">
                <div class="row clearfix">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label i18n>First name</label>
                            <input type="text"
                                   id="name"
                                   name="name"
                                   placeholder=""
                                   [ngClass]="{'is-invalid':form.get('first_name').touched && form.get('first_name').invalid}"
                                   class="form-control"
                                   formControlName="first_name"
                                   required="" ngModel
                                   aria-required="true">
                            <div class="invalid-feedback">
                                <div i18n>Firstname is required</div>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="row clearfix">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label i18n>Last name</label>
                            <input type="text"
                                   id="last_name"
                                   name="last_name"
                                   placeholder=""
                                   [ngClass]="{'is-invalid':form.get('last_name').touched && form.get('last_name').invalid}"
                                   class="form-control"
                                   formControlName="last_name"
                                   required="" ngModel
                                   aria-required="true">
                            <div class="invalid-feedback">
                                <div i18n>Lastname is required</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">

                <div class="col-sm-12">
                    <div class="form-group">
                        <label i18n>City</label>
                        <input type="text"
                               id="city"
                               name="city"
                               placeholder=""
                               [ngClass]="{'is-invalid':form.get('city').touched && form.get('city').invalid}"
                               class="form-control"
                               formControlName="city"
                               required="" ngModel
                               aria-required="true">
                        <div class="invalid-feedback">
                            <div i18n>City is required</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-sm-12">
                    <div class="form-group">
                        <label i18n>Street</label>
                        <input type="text"
                               id="street"
                               name="street"
                               placeholder=""
                               [ngClass]="{'is-invalid':form.get('street').touched && form.get('street').invalid}"
                               class="form-control"
                               formControlName="street"
                               required="" ngModel
                               aria-required="true">
                        <div class="invalid-feedback">
                            <div i18n>Street is required</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-sm-12">
                    <div class="form-group">
                        <label i18n>Phone</label>
                        <input type="text"
                               id="phone"
                               name="phone"
                               placeholder=""
                               [ngClass]="{'is-invalid':form.get('phone').touched && form.get('phone').invalid}"
                               class="form-control"
                               formControlName="phone"
                               required="" ngModel
                               aria-required="true">
                        <div class="invalid-feedback">
                            <div i18n>Phone is required</div>
                        </div>
                    </div>
                </div>

            </div>

            <br>

            <div class="text-right">
                <button id="close_new_user_btn" class="btn btn-default" (click)="close()" i18n>Close
                </button>
                <button id="save_new_user_btn" class="btn btn-success" (click)="form.valid && add_update()" i18n>
                    Save
                </button>

            </div>
        </form>
    </div>
</div>
